import React, { useState, useEffect } from "react";
import { Progress } from "antd";
import axios from "axios";

var declare_ip_public = true;
function Reconnect({ reconnectionWebphone }) {
  useEffect(() => {
    reconnectionWebphone();
  }, []);
  // addEventListener version
  // window.addEventListener("online", (event) => {
  //   if (declare_ip_public) {
  //     declare_ip_public = false;
  //     console.log("coonn");
  //     const ipPublic = _axios
  //       .get(
  //         `https://${BackendURL}:4444/${ window.switchAPI === "govoice" ? "govoice" : "comunik_ipbx" }/Api/WS/IpPublicIPBXV3API?compte=${UserService.getcompte()}&poste=${UserService.getPoste()}`
  //         // config
  //       )
  //       .then(function (response) {
  //         const declareIp = _axios
  //           .get(
  //             `https://${BackendURL}:4444/${ window.switchAPI === "govoice" ? "govoice" : "comunik_ipbx" }/Api/WS/IPCOMUNIKSOFTPHONEDECLARWS?compte=${UserService.getcompte()}&adresse_ip=${
  //               response.data.ip_public
  //             }&poste=${UserService.getPoste()}`
  //             // config
  //           )
  //           .then(function (response) {})
  //           .catch(function (error) {});
  //       })
  //       .catch(function (error) {});
  //   }
  // });

  // window.addEventListener("offline", (event) => {
  //   declare_ip_public = true;
  // });

  return (
    <div>
      <div id="loading"></div>
    </div>
  );
}

export default Reconnect;
